<script>
import TableList from '@/components/TableList.vue'
import * as components from './TableList/'
export default {
  extends: TableList,
  components
}
</script>
<style lang="scss">
body.page-cash-flow {
  .filter-preview {
    display: none;
  }
}
.table-list.cash-flow {
  td.column-price {
    text-transform: uppercase;
  }
}
</style>
